'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroDefinition = require('./NitroDefinition');

var _NitroDefinition2 = _interopRequireDefault(_NitroDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroDefinition2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-definition/index.js
// module id = 234
// module chunks = 4